import * as commonActionTypes from "../../shared/commonActionTypes";

const initialState = { actionId: 0, actionDescription: "", projectId: "", screenId: "" };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case commonActionTypes.SET_ACTION:
      return {
        actionId: action.actionId,
        actionDescription: action.actionDescription,
        projectId: action.projectId,
        screenId: action.screenId
      };

    case commonActionTypes.LOGOUT:
    case commonActionTypes.SET_CONTEXT:
    case commonActionTypes.SET_MATTER:
    return initialState;
    default:
      return state;
  }
};

export default reducer;
